import React, { useState, useEffect, useCallback, useMemo } from "react";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { isDesktop, isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";

var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export function Layout30(props) {
    const [bgDesktop, setbgDesktop] = useState("");
    const [bgMobile, setbgMobile] = useState("");
    const [showShimmer, setShowShimmer] = useState(true);
    const [showdetails, setshowdetails] = useState(false);
    const [details, setdetails] = useState(false);
    const [SVGIcon, setSVGIcon] = useState("");
    const [ImageData, setImageData] = useState("");
    // const handleTimeout = useCallback(() => {
    //     setShowShimmer(false);
    // }, []);

    // useEffect(() => {
    //     // const timer = setTimeout(() => {
    //     setShowShimmer(false);
    //     // }, 1000);

    //     // return () => {
    //     //     clearTimeout(timer);
    //     // };
    // }, [handleTimeout]);


    useEffect(() => {
        let imageDesktop = props.bgGoldenDesk ? props.bgGoldenDesk : props.bgSilverDesk;
        let imageMobile = props.bgGoldenMob ? props.bgGoldenMob : props.bgSilverMob;
        setbgDesktop(imageDesktop);
        setbgMobile(imageMobile);
        SVGIcons().then(setSVGIcon);
        ImgIcons().then(setImageData);
    }, [props.bgGoldenDesk, props.bgGoldenMob, props.bgSilverDesk, props.bgSilverMob]);

    function showdetailspop(data) {
        setshowdetails(true);
        setdetails(data);
    }

    let Closepopup = () => {
        setshowdetails(false);
    };

    const premiumIcon = useMemo(() => (
        <img src={props.silverIcon} style={{ width: "1.3rem", marginRight: "4px", marginBottom: "2px" }} className="DIconTablet" alt="DocuBayImg" />
    ), [props.silverIcon]);

    const originalIcon = useMemo(() => (
        <img src={props.goldenIcon} style={{ width: "1.3rem", marginRight: "4px", marginBottom: "2px" }} className="DIconTablet" alt="DocuBayImg" />
    ), [props.goldenIcon]);

    return (
        <>
            <section className="mb-0">
                <div className="Layout30" style={{ background: isMobile ? `url(${bgMobile})` : `url(${bgDesktop})`, }}>
                    {/* {showShimmer ? (
                        <div className="line linedesk linehead" />
                    ) : ( */}
                    <>
                        <div className="DocuOri-layout">
                            <img src={props.originalLogo} alt="original" />
                        </div>
                    </>
                    {/* )} */}
                    <div>
                        <Swiper
                            navigation={isDesktop ? { prevEl: ".slick-prev", nextEl: ".slick-next" } : false}
                            slidesPerView={2.4}
                            spaceBetween={16}
                            freeMode={true}
                            loop={false}
                            centeredSlides={false}
                            breakpoints={{
                                650: { slidesPerView: 1 },
                                700: { slidesPerView: 4.2 },
                                810: { slidesPerView: 4.4 },
                                850: { slidesPerView: 6.3 },
                            }}
                            modules={[FreeMode, Pagination, Navigation]}
                            className="Layout30-slider"
                        >
                            <div className="side-overlay-L dD-block"></div>
                            <button className="slick-prev slick-arrow" type="button" aria-label="Previous" />
                            {props.Layout1.map((data, index) => {
                                const keywords = data.keywords.split(",");
                                const isPremium = data.premium && !data.original_tag;
                                const isOriginal = data.original_tag && data.premium;
                                return (
                                    <SwiperSlide key={index} className="temp14-item">
                                        {/* {showShimmer ? (
                                            <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                                        ) : ( */}
                                        <>
                                            <div className="dD-none" onClick={() => { showdetailspop(data); }}>
                                                <div className="temp14-itemColor Layout30-itemColor">
                                                    <img src={data.vertical_banner.small} alt="DocuBay" />
                                                </div>
                                                <div className="bay-title" style={{ color: "#000", paddingRight: "16px" }}>{keywords[0]}</div>
                                                <div className="premium-red">
                                                    {isPremium && premiumIcon}
                                                    {isOriginal && originalIcon}
                                                </div>
                                            </div>
                                            <Link to={"/" + data.slug} className="dD-block">
                                                <div className="temp14-itemColor Layout30-itemColor">
                                                    <img src={data.vertical_banner.small} alt="DocuBay" />
                                                </div>
                                                <div className="bay-title" style={{ color: "rgb(255, 255, 255)", paddingRight: "16px" }}>{keywords[0]}</div>
                                                <div className="premium-red">
                                                    {isPremium && premiumIcon}
                                                    {isOriginal && originalIcon}
                                                </div>
                                            </Link>
                                        </>
                                        {/* )} */}
                                    </SwiperSlide>
                                );
                            })}
                            <SwiperSlide></SwiperSlide>
                            <div className="side-overlay-R dD-block"></div>
                            <button
                                className="slick-next slick-arrow"
                                type="button"
                                aria-label="Next"
                            />
                        </Swiper>
                    </div>
                </div>
            </section>
            {showdetails ? (
                <Showdetailspopup
                    data={details}
                    Closebtn={Closepopup}
                    silverIcon={props.silverIcon}
                    goldenIcon={props.goldenIcon}
                />
            ) : null}
        </>
    );
}
export default Layout30;